import { useTranslation } from 'react-i18next';

export default function Marquee() {
  const { t } = useTranslation();
  const items = [
    'marquee.item1',
    'marquee.item2',
    'marquee.item3',
    'marquee.item4',
    'marquee.item5',
    'marquee.item6',
    'marquee.item7',
  ];
  const doubled = [...items, ...items];

  return (
    <section className="w-full bg-foreground-950 border-t border-background-50/10 overflow-hidden py-6">
      <div className="flex animate-marquee whitespace-nowrap">
        {doubled.map((k, i) => (
          <div key={i} className="flex items-center gap-4 mx-8">
            <div
              className="w-3 h-3 bg-primary-500"
              style={{ clipPath: 'polygon(50% 0%, 100% 100%, 0% 100%)' }}
            />
            <span className="text-background-100 text-sm font-mono-tech tracking-[0.25em] uppercase">
              {t(k)}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}